// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"66493019","703":"d29ac12e","787":"c2de28b5"}[chunkId] + ".chunk.js";
};